import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ReferencesPage = lazy(() => import('../pages/references/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CookiePage = lazy(() => import('../pages/cookie/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/referanslar',
    element: <ReferencesPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/gizlilik',
    element: <KVKKPage />,
  },
  {
    path: '/cerez',
    element: <CookiePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
